import type { InterventionLite } from "@/entities/intervention";
import type { UseListOptions } from "@/hooks/queries";

import { useList } from "@/hooks/queries";

export const useGetInterventions = (
  options?: UseListOptions<InterventionLite>
) => {
  const { data, ...queryResult } = useList<InterventionLite>(
    "interventions",
    options
  );

  return {
    interventions: data?.data ?? [],
    ...queryResult,
  };
};
